import getConfig from 'next/config';
import { TDropdownList } from './DropdownComponent';
const { publicRuntimeConfig } = getConfig();

// interface IProduct {
//   name: string;
//   url?: string;
//   child: {
//     id: string;
//     url: string;
//     title: string;
//     icon?: string;
//   }[];
// }

// interface IDropdown {
//   name: string;
//   link: string;
// }
export type THeaderLabels = {
  about_us: string;
  solutions: string;
  why_cleartax: string;
  sa_resources: string;
  contact_us: string;
  language: string;
  demo: string;
  login: string;
};
export const HEADER_LABELS: {
  English: THeaderLabels;
  Arabic: THeaderLabels;
  French: THeaderLabels;
  Spanish: THeaderLabels;
  Polish: THeaderLabels;
  Malay: THeaderLabels;
  Dutch: THeaderLabels;
  Filipino: THeaderLabels;
} = {
  English: {
    about_us: 'About Us',
    solutions: 'Solutions',
    why_cleartax: 'Why Cleartax',
    sa_resources: 'Resources',
    contact_us: 'Contact Us',
    language: 'English',
    demo: 'Book a demo',
    login: 'Login/Signup',
  },
  Arabic: {
    about_us: 'نبذة عن الشركة',
    solutions: 'الحلول',
    why_cleartax: 'لماذا كليرتاكس',
    sa_resources: 'الموارد',
    contact_us: 'تواصل معنا',
    language: 'العربية',
    demo: 'احجز عرضًا توضيحيا',
    login: 'تسجيل الدخول',
  },
  French: {
    about_us: 'About Us',
    solutions: 'Solutions',
    why_cleartax: 'Why Cleartax',
    sa_resources: 'Resources',
    contact_us: 'Contact Us',
    language: 'English',
    demo: 'Book a demo',
    login: 'Login/Signup',
  },
  Spanish: {
    about_us: 'About Us',
    solutions: 'Solutions',
    why_cleartax: 'Why Cleartax',
    sa_resources: 'Resources',
    contact_us: 'Contact Us',
    language: 'English',
    demo: 'Book a demo',
    login: 'Login/Signup',
  },
  Polish: {
    about_us: 'About Us',
    solutions: 'Solutions',
    why_cleartax: 'Why Cleartax',
    sa_resources: 'Resources',
    contact_us: 'Contact Us',
    language: 'English',
    demo: 'Book a demo',
    login: 'Login/Signup',
  },
  Malay: {
    about_us: 'About Us',
    solutions: 'Solutions',
    why_cleartax: 'Why Cleartax',
    sa_resources: 'Resources',
    contact_us: 'Contact Us',
    language: 'English',
    demo: 'Book a demo',
    login: 'Login/Signup',
  },
  Dutch: {
    about_us: 'Over ons',
    solutions: 'Oplossingen',
    why_cleartax: 'Waarom Cleartax',
    sa_resources: 'Bronnen',
    contact_us: 'Neem contact op',
    language: 'Dutch',
    demo: 'Plan een demo',
    login: 'Inloggen/Registreren',
  },
  Filipino: {
    about_us: 'Tungkol sa Amin',
    solutions: 'Mga Solusyon',
    why_cleartax: 'Bakit Cleartax',
    sa_resources: 'Mga Mapagkukunan',
    contact_us: 'Makipag-ugnayan sa Amin',
    language: 'Filipino',
    demo: 'Mag-book ng demo',
    login: 'Mag-login/Mag-signup',
  },
};

export const CONTACT_US_PAGE = 'https://www.cleartax.com/sa/contact-us';

export const ABOUT_US: TDropdownList = [
  {
    name: 'Company',
    name_ar: 'الشركة',
    link: 'https://www.cleartax.com/sa/about-us',
  },
  {
    name: 'Customers',
    name_ar: 'العملاء',
    link: 'https://www.cleartax.com/sa/customers',
  },
  {
    name: 'Press',
    name_ar: 'صحافة',
    link: 'https://www.cleartax.com/sa/press',
  },
];

export const SOLUTIONS: TDropdownList = [
  {
    name: 'E-invoicing Software',
    name_ar: 'الفوترة الإلكترونية',
    link: 'https://www.cleartax.com/sa/e-invoicing-software',
  },
  {
    name: 'API Integration',
    name_ar: 'التكامل',
    link: 'https://www.cleartax.com/sa/e-invoicing-integration',
  },
  {
    name: 'Accounts Payable Automation',
    name_ar: 'أتمتة الحسابات الدائنة',
    link: 'https://www.cleartax.com/sa#ksa-einvoicing-promises',
  },
  {
    name: 'Accounts Receivable Automation',
    name_ar: 'أتمتة الحسابات المدينة',
    link: 'https://www.cleartax.com/sa#ksa-einvoicing-promises',
  },
  {
    name: 'Supply Chain Financing',
    name_ar: 'تمويل سلسلة التوريد',
    link: 'https://www.cleartax.com/sa#ksa-einvoicing-promises',
  },
];

const WHY_CLEARTAX: TDropdownList = [
  {
    name: 'For Businesses',
    name_ar: 'للأعمال',
    link: 'https://www.cleartax.com/sa/business',
  },
  {
    name: 'For Partners',
    name_ar: 'للشركاء فقط',
    link: 'https://www.cleartax.com/sa/partners',
  },
];

const SA_RESOURCES: TDropdownList = [
  {
    name: 'Webinars',
    name_ar: 'الوبينار',
    link: 'https://www.cleartax.com/sa/ksa-einvoicing',
  },
  {
    name: 'Blog',
    name_ar: 'المدونات',
    link: 'https://www.cleartax.com/sa/ksa-einvoicing',
  },
];

export const MORE_OPTION = [
  {
    name: 'About Us',
    link: 'https://clear.in/s/about-us',
  },
  {
    name: 'Careers',
    link: 'https://clear.in/s/careers',
  },
  {
    name: 'ClearChronicles',
    link: 'https://news.cleartax.in/',
  },
  {
    name: 'Glossary',
    link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/g/terms/`,
  },
  {
    name: 'Webinars',
    link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/webinars`,
  },
  {
    name: 'Trust & Safety',
    link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/trust`,
  },
];

export const PRODUCT_OPTION = [
  {
    name: 'ENTERPRISE',
    url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/enterprise`,
    seeAllButton: {
      id: 'seeAll',
      url: 'https://cleartax.in/enterprise',
      title: 'See all',
    },
    child: [
      {
        id: 'gst',
        url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/gst`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1645192552_group2860.svg',
        title: 'GST',
      },
      {
        id: 'maxITC',
        url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/max-itc`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1645425887_group3306.png',
        title: 'MaxITC',
      },
      {
        id: 'einvoicing_discounting',
        url: 'https://clear.in/invoice-discounting',
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1645437399_group.png',
        title: 'Invoice Discounting',
      },
      {
        id: 'e-invoice_bill',
        url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/e-invoicing-enterprise-software`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1645437697_group.png',
        title: 'E-Invoicing & E-Way Bill',
      },
      {
        id: 'tds',
        url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/tds`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1645437865_group3621.png',
        title: 'TDS',
      },
    ],
  },
  {
    name: 'Individuals',
    url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/you`,
    seeAllButton: {
      id: 'seeAll',
      url: 'https://cleartax.in/you',
      title: 'See all',
    },
    child: [
      {
        id: 'itr',
        url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/income-tax-efiling`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1645426019_group2830.png',
        title: 'ITR Filing',
      },
      {
        id: 'taxPlanning',
        url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/planning/`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1671698817_calculator2.png',
        title: 'Tax Planning',
      },
      {
        id: 'black',
        url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/save`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1645426108_group3283.png',
        title: 'Black (Save & Invest)',
      },
    ],
  },
  {
    name: 'More Options',
    child: [
      {
        id: 'clearone',
        url: 'https://clear.in/clearone',
        title: 'ClearOne - Invoicing for SMEs',
      },
      {
        id: 'tax_experts',
        url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/tax-experts`,
        title: 'Products for Tax Experts',
      },
      {
        id: 'tax_consultant',
        url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/services/`,
        title: 'Tax Consultant Services',
      },
      {
        id: 'crypto_taxation',
        url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/crypto-tax`,
        title: 'Crypto Taxation',
      },
      {
        id: 'mf',
        url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/mutual-funds/`,
        title: 'Mutual Funds',
      },
    ],
  },
];

export const PRODUCT_OPTION_V2 = [
  {
    name: 'INDIVIDUAL PRODUCTS',
    url: '',
    child: [
      {
        id: 'gst',
        url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/gst`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1645192552_group2860.svg',
        title: 'GST',
      },
      {
        id: 'e-invoice_bill',
        url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/e-invoicing-enterprise-software`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1645437697_group.png',
        title: 'E-Invoicing & E-Way Bill',
      },
      {
        id: 'tds',
        url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/tds`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1645437865_group3621.png',
        title: 'TDS',
      },
      {
        id: 'maxITC',
        url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/max-itc`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1645425887_group3306.png',
        title: 'MaxITC',
      },
      {
        id: 'einvoicing_discounting',
        url: 'https://clear.in/invoice-discounting',
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1645437399_group.png',
        title: 'Invoice Discounting',
      },
      {
        id: 'cc',
        url: 'https://www.clear.in/capture',
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1656318963_cc21.png',
        title: 'Clear Capture',
      },
      {
        id: 'cimplyfive',
        url: 'https://www.clear.in/s/secretarial-automation-software',
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1671626025_gearsixcimply5.png',
        title: 'Cimplyfive',
      },
    ],
  },
  {
    name: 'PRODUCT SUITES',
    url: '',
    child: [
      {
        id: 'cfc',
        url: 'https://www.clear.in/clear-finance-cloud',
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1671532710_group3627cfc.png',
        title: 'Clear Finance Cloud',
      },
      {
        id: 'ccc',
        url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/clear-compliance-cloud`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1671532876_clipboardtextccc.png',
        title: 'Clear Compliance Cloud',
      },
      {
        id: 'cscc',
        url: `https://cleartax.in/supply-chain-automation-solution`,
        icon: 'https://assets.clear.in/cleartax/images/1716990871_supplaychain_.svg',
        title: 'Clear Supply Chain Cloud',
      },
    ],
  },
];

export const RESOURCES_V2 = [
  {
    name: 'READ',
    child: [
      {
        id: 'caseStudy',
        url: 'https://cleartax.in/s/enterprise-case-studies',
        title: 'Case studies',
      },
      {
        id: 'whitePapers',
        url: 'https://cleartax.in/s/enterprise-whitepapers',
        title: 'White Papers',
      },
      {
        id: 'blog',
        url: 'https://cleartax.in/income-tax-efiling?#guide-section',
        title: 'Blog',
      },
      {
        id: 'productGuides',
        url: 'https://docs.cleartax.in/product-help-and-support/',
        title: 'Product Guides',
      },
      {
        id: 'newsroom',
        url: 'https://news.cleartax.in/',
        title: 'Newsroom',
      },
    ],
  },
  {
    name: 'WATCH',
    url: '',
    child: [
      {
        id: 'webinars',
        url: 'https://cleartax.in/s/webinars',
        title: 'Webinars',
      },
      {
        id: 'productGuideVideos',
        url: 'https://docs.cleartax.in/product-help-and-support/video-tutorials',
        title: 'Product Guides - Videos',
      },
    ],
  },
  {
    name: 'ENGAGE',
    url: '',
    child: [
      {
        id: 'events',
        url: 'https://cleartax.in/s/webinars',
        title: 'Events',
      },
      {
        id: 'faqs',
        url: 'https://docs.cleartax.in/product-help-and-support/video-tutorials',
        title: 'FAQs',
      },
      {
        id: 'helpCenter',
        url: 'https://docs.cleartax.in/product-help-and-support/video-tutorials',
        title: 'Help Center (Product Support)',
      },
    ],
  },
];

export const SOLUTIONS_V2 = [
  {
    id: 'black',
    link: 'https://cleartax.in/s/enterprise-CFOs',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1665480571_group18144783.png',
    name: 'CFO',
  },
  {
    id: 'for_industries',
    name: 'For Industries',
    child: [
      {
        id: 'startups',
        link: 'https://cleartax.in/s/start-up',
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1665480559_group18142282.png',
        name: 'Startups',
      },
      {
        id: 'fmcg',
        link: 'https://www.clear.in/fmcg-solutions',
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1671625137_group1000002454fmcg.png',
        name: 'FMCG',
      },
    ],
  },
];

export const COMPANY = [
  {
    name: 'Support',
    link: 'https://www.clear.in/s/contact-us',
  },
  {
    name: 'About Us',
    link: 'https://clear.in/s/about-us',
  },
  {
    name: 'Careers',
    link: 'https://clear.in/s/careers',
  },
  {
    name: 'Media & Press',
    link: 'https://clear.in/s/press',
  },
  {
    name: 'Trust & Safety',
    link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/trust`,
  },
];

export const MY_ACCOUNTS = [
  {
    name: 'My tax returns',
    link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/filing/itr-filings?utm_ref=content_pages_navbar`,
  },
  {
    name: 'Tax filing from expert',
    link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/pricing?utm_ref=content_pages_navbar`,
  },
  {
    name: 'My orders',
    link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/services/my_orders?utm_ref=content_pages_navbar`,
  },
  {
    name: 'My rewards',
    link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/rewards/myrewards?utm_ref=content_pages_navbar`,
  },
  {
    name: 'My investments',
    link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/save/dashboard/portfolio?ref=static-login-dropdown&utm_ref=content_pages_navbar`,
  },
  {
    name: 'All Products',
    link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/launchpad?source=home&utm_ref=content_pages_navbar`,
  },
  {
    name: 'Profile',
    link: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/filing/profile?utm_ref=content_pages_navbar`,
  },
];
